import { useState } from 'react'
import { SearchableSelect } from '@/shared/components/ui/SearchableSelect'
import { PartyFormModal } from '@/modules/registrations/contacts/PartyFormModal'
import type { Party } from '@/modules/registrations/contacts/contactsTypes'

interface PartySelectOption {
  value: string
  label: string
}

interface PartySelectProps {
  unitId: string
  options: PartySelectOption[]
  value: string
  onChange: (value: string) => void
  /** Called after a new party is created so the parent can refresh its list */
  onPartyCreated?: (party: Party) => void
  placeholder?: string
  disabled?: boolean
  error?: boolean
}

export function PartySelect({
  unitId,
  options,
  value,
  onChange,
  onPartyCreated,
  placeholder = 'Selecionar contato...',
  disabled = false,
  error = false
}: PartySelectProps) {
  const [modalOpen, setModalOpen] = useState(false)

  function handleCreated(party: Party) {
    onPartyCreated?.(party)
    onChange(party.id)
  }

  return (
    <>
      <div className="flex items-center gap-2">
        <div className="flex-1 min-w-0">
          <SearchableSelect
            options={options}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            disabled={disabled}
            error={error}
          />
        </div>

        <button
          type="button"
          onClick={() => setModalOpen(true)}
          disabled={disabled}
          title="Novo contato"
          className="shrink-0 flex items-center justify-center w-9 h-9 rounded-lg border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-700 text-slate-600 dark:text-slate-300 hover:bg-slate-50 hover:border-emerald-400 hover:text-emerald-600 dark:hover:bg-emerald-900/20 dark:hover:text-emerald-400 transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
        >
          <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
          </svg>
        </button>
      </div>

      <PartyFormModal
        unitId={unitId}
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        onCreated={handleCreated}
      />
    </>
  )
}
